import PropTypes from 'prop-types';
import React from 'react';
import { spotReportPath } from '../../utils/urls';
import MetaTags from '../MetaTags';

const title = (spotName, cameras, multiCam) => {
  if (multiCam) {
    return `${spotName} Surf Report, Live Surf Cams & 17-Day Surf Forecast - Surfline`;
  }
  if (cameras && cameras[0]) {
    return `${spotName} Surf Report, Live Surf Cam & 17-Day Surf Forecast - Surfline`;
  }
  return `${spotName} Surf Report & 17-Day Surf Forecast - Surfline`;
};
const description = (spotName, cameras, multiCam, report) => {
  const hasCamera = cameras && cameras[0];
  if (multiCam && report) {
    return `Get today's most accurate ${spotName} surf report with multiple live HD surf cams for current swell, wind, and wave conditions. With full written report (updated twice daily) and 17-day surf forecasts, so you can know before you go.`;
  }
  if (multiCam && !report) {
    return `Get today's most accurate ${spotName} surf report with multiple live HD surf cams for current swell, wind, and wave conditions. With proprietary LOLA report on swell, wind and waves and 17-day surf forecasts, so you can know before you go.`;
  }
  if (hasCamera && report) {
    return `Get today's most accurate ${spotName} surf report with live HD surf cam for current swell, wind and wave conditions. With full written report (updated twice daily) and 17-day surf forecasts, so you can know before you go.`;
  }
  if (!hasCamera && report) {
    return `Get today's most accurate ${spotName} surf report. With full written report (updated twice daily) on swell, wind and waves and 17-day surf forecasts, so you can know before you go.`;
  }
  return `Get today's most accurate ${spotName} surf report. With proprietary LOLA report on swell, wind and waves and 17-day surf forecasts, so you can know before you go.`;
};

const urlPath = (spotId, spotName) => spotReportPath({ _id: spotId, name: spotName });
const image = cameras => cameras && cameras[0] && cameras[0].control;

const SpotPageMeta = ({ spotName, spotId, cameras, multiCam, report }) => (
  <MetaTags
    title={title(spotName, cameras, multiCam)}
    description={description(spotName, cameras, multiCam, report)}
    urlPath={urlPath(spotId, spotName)}
    image={image(cameras)}
  />
);

SpotPageMeta.propTypes = {
  spotId: PropTypes.string.isRequired,
  spotName: PropTypes.string.isRequired,
  report: PropTypes.bool,
  multiCam: PropTypes.bool,
  cameras: PropTypes.arrayOf(
    PropTypes.shape({
      stillUrl: PropTypes.string,
    })
  ),
};

SpotPageMeta.defaultProps = {
  cameras: [],
  report: false,
  multiCam: false,
};

export default SpotPageMeta;
